module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"associationAssignments":{"title":"Association assignments"},"unionAssignments":{"title":"Union assignments"}},"fi":{"associationAssignments":{"title":"Yhdistystehtävät"},"unionAssignments":{"title":"Liittotehtävät"}}}')
  delete Component.options._Ctor
}
